module.exports = __webpack_public_path__ + "img/home_page.b3b4eb2f.png";